import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { Component } from "@contember/binding";
import { RepeaterInner } from "../../collections/Repeater/RepeaterInner.js";
const MutableEntityListRenderer = Component(
  ({
    beforeContent,
    afterContent,
    ...repeaterInnerProps
  }) => {
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      beforeContent,
      /* @__PURE__ */ jsx(RepeaterInner, { label: void 0, ...repeaterInnerProps }),
      afterContent
    ] });
  },
  ({ beforeContent, afterContent, ...repeaterInnerProps }, environment) => /* @__PURE__ */ jsxs(Fragment, { children: [
    beforeContent,
    RepeaterInner.staticRender(
      {
        label: void 0,
        ...repeaterInnerProps
      },
      environment
    ),
    afterContent
  ] }),
  "MutableEntityListRenderer"
);
export {
  MutableEntityListRenderer
};
//# sourceMappingURL=MutableEntityListRenderer.js.map
